export const OutsideTemperaturesValues = [-20, -10, 0, 10, 20, 30] as const;
export type OutsideTemperatures = typeof OutsideTemperaturesValues[number];

export const WEIGHT_PAYLOAD_STEP = 100;

export enum ChargingLocation {
  home = 'atHome',
  work = 'atWork',
  public = 'atPublic',
  motorway = 'atHighway',
}

export enum PayloadPeopleValues {
  one = 'one',
  multiple = 'multiple',
}

export interface DrivingProfile<T = number> {
  /**
   *  The percentage of driving the specific profile does in the city.
   *  Value MUST be less than 100.
   *
   *  @examples [45]
   */
  city: T;
  /**
   *  The percentage of driving the specific profile does in the city.
   *  Value MUST be less than 100.
   *
   *  @examples [30]
   */
  country: T;
}
